module.exports = __webpack_public_path__ + "static/media/emptyData.58fd9bda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity50/emptyData.png
// module id = 348
// module chunks = 0